import CookieConsent from "vanilla-cookieconsent/dist/cookieconsent.umd";

document.addEventListener('DOMContentLoaded', () => {
	const element = document.querySelectorAll('.cookie-consent');

	if (!element.length) {
		return;
	}

	// const privacyPolicyLink = element[0].dataset.privacyPolicyLink;
	const contactLink = element[0].dataset.contactLink;

	const cc = CookieConsent.run({
		categories: {
			necessary: {
				enabled: true,
				readOnly: true
			},
			analytics: {}
		},

		language: {
			default: 'cs',
			translations: {
				cs: {
					consentModal: {
						title: '🍪 Používám cookies!',
						description: 'Soubory cookies a další technologie mi pomáhají zlepšovat moje služby, pomáhají mi analyzovat výkon webu. V nastavení si můžete vybrat, které cookies můžu používat.',
						acceptAllBtn: 'Povolit vše',
						acceptNecessaryBtn: 'Zamítnout vše',
						showPreferencesBtn: 'Podrobné nastavení'
					},
					preferencesModal: {
						title: 'Nastavení cookies',
						acceptAllBtn: 'Povolit vše',
						acceptNecessaryBtn: 'Zamítnout vše',
						savePreferencesBtn: 'Povolit zvolené nastavení',
						closeIconLabel: 'Zavřít',
						sections: [
							{
								title: 'Využívání technologie cookies 📢',
								description: 'Soubory cookies a další technologie mi pomáhají zlepšovat moje služby, pomáhají mi analyzovat výkon webu. Nastavení můžete pro každou kategorií kdykoliv změnit.'
							},
							{
								title: 'Nezbytné cookies',
								description: 'Tyto cookies jsou nezbytně nutné pro správnou funkci webu - zajišťují správné zobrazení, odesílání formulářů a podobně. Technické cookies není možné vypnout.',
								linkedCategory: 'necessary',
								cookieTable: {
									caption: 'Seznam cookies',
									headers: {
										name: 'Název',
										description: 'Popis',
										duration: 'Doba'
									},
									body: [
										{
											name: 'PHPSESSID',
											description: 'This cookie is native to PHP applications. The cookie is used to store and identify a users unique session ID for the purpose of managing user session on the website. The cookie is a session cookies and is deleted when all the browser windows are closed.',
											duration: '1 day'
										},
										{
											name: '_nss',
											description: '',
											duration: ''
										}
									]
								}
							},
							{
								title: 'Analytické a statistické cookies',
								description: 'Statistické cookies používám k vyhodnocování výkonu mého webu a reklamních kampaní. Pomocí cookies určuji počet návštěv, zdroje návštěvnosti a chování zákazníků na mém webu.',
								linkedCategory: 'analytics',
								cookieTable: {
									caption: 'Seznam cookies',
									headers: {
										name: 'Název',
										description: 'Popis',
									},
									body: [
										{
											name: '_ga',
											description: 'The _ga cookie, installed by Google Analytics, calculates visitor, session and campaign data and also keeps track of site usage for the site\'s analytics report. The cookie stores information anonymously and assigns a randomly generated number to recognize unique visitors.',
										}
									]
								}
							},
							// {
							// 	title: 'Reklamní a marketingové',
							// 	description: 'Marketingové cookies využívají moji partneři k zobrazování relevantní reklamy na základě vašich preferencí. Tato personalisovaný obsah se může zobrazovat na webech třetích stran, které využívají moji partneři k zobrazování reklamních sdělení.',
							// 	linkedCategory: 'targeting'
							// },
							{
								title: 'Více informací',
								description: 'V případě dalších dotazů, týkajících se používání cookies mě prosím <a class="cc-link" href=' + contactLink + '>kontaktujte</a>.'
							}
						]
					}
				}
			}
		}
	})
});
